import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthStatusView } from "./AuthStatusView";
import { useAuthSessionOrchestrator } from "./AuthSessionOrchestrator";

/**
 * Handles the Auth0 logout return route outside the normal WorkUI shell.
 */
export function Auth0LogoutPage() {
  const navigate = useNavigate();
  const { beginLogin, stage } = useAuthSessionOrchestrator();
  const hasStartedLoginRef = useRef(false);
  const hasNavigatedRef = useRef(false);

  useEffect(() => {
    if (stage.status === "authenticated") {
      hasStartedLoginRef.current = false;

      if (!hasNavigatedRef.current) {
        hasNavigatedRef.current = true;
        navigate("/", { replace: true });
      }

      return;
    }

    hasNavigatedRef.current = false;

    if (stage.status !== "signed-out" || stage.mode !== "auth0") {
      hasStartedLoginRef.current = false;
      return;
    }

    if (hasStartedLoginRef.current) {
      return;
    }

    hasStartedLoginRef.current = true;
    void beginLogin("/");
  }, [beginLogin, navigate, stage]);

  if (stage.status === "signed-out" && stage.mode === "auth0") {
    return <AuthStatusView status="redirecting-to-login" />;
  }

  if (stage.status === "error") {
    return (
      <AuthStatusView
        message={stage.message}
        onRetry={() => void beginLogin("/")}
        reason={stage.reason}
        status="error"
      />
    );
  }

  return <AuthStatusView status="logging-out" />;
}
